import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

export const companyShiftSchema = yup.object().shape({
  name: yup.string().required(t('errors.required', { label: 'Nome' })),
  start_time: yup.string()
    .required(t('errors.required', { label: 'Hora de início' }))
    .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Formato inválido. Use HH:MM'),
  end_time: yup.string()
    .required(t('errors.required', { label: 'Hora de término' }))
    .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Formato inválido. Use HH:MM'),
})
